import React from "react";
import styled from "styled-components";
import ClipboardCopy from "./ClipboardCopy";
import KakaoShareButtonT from "./KakaoShareButtonT";

const Share = () => {
  return (
    <Container>
      <KakaoShareButtonT />
      <ClipboardCopy />
    </Container>
  );
};

export default Share;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 30px;
`;
